import React from 'react';

// Simple skeleton loader; extend with variants as needed
export interface SkeletonLoaderProps {
  lines?: number; // number of placeholder lines
  lineHeight?: number; // px height of each line
  animate?: boolean; // shimmer effect toggle
  width?: string; // overall width
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
    lines = 3,
    lineHeight = 14,
    animate = true,
    width = '100%'
}) => {
  return (
    <div className={`em-skeleton ${animate ? 'em-skeleton-animate' : ''}`} style={{ width }}>
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          style={{
              height: lineHeight,
              borderRadius: 4,
              background: 'var(--skeleton-bg, #eee)',
              marginBottom: i === lines - 1 ? 0 : 8,
              overflow: 'hidden',
              position: 'relative'
          }}
          className="em-skeleton-line"
        >
          {animate && (
            <div
              style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.5) 50%, rgba(255,255,255,0) 100%)',
                  animation: 'em-skeleton-shimmer 1.4s infinite'
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
